/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { Sexe } from '@/enums';

// Libellé du sexe tel que relu par l'API dans `sexeCode` (affiché sur la fiche).
const LIBELLE_BY_SEXE: Record<string, string> = {
  [Sexe.Homme]: 'Masculin',
  [Sexe.Femme]: 'Féminin',
  [Sexe.Indetermine]: 'Indéterminé',
};

const sexeToLibelle = (sexe?: string | null): string | null =>
  (sexe && LIBELLE_BY_SEXE[sexe]) ?? null;

export default sexeToLibelle;
